import React from 'react';

function RatingStars({ rating }) {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  // Добавляем заполненные звезды
  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <span key={`full-${i}`} className="text-yellow-500">★</span>
    );
  }

  // Добавляем полузаполненную звезду если нужно
  if (hasHalfStar) {
    stars.push(
      <span key="half" className="relative">
        <span className="text-gray-300">★</span>
        <span className="absolute inset-0 text-yellow-500 overflow-hidden" style={{ width: '50%' }}>★</span>
      </span>
    );
  }

  // Добавляем пустые звезды
  const emptyStars = 5 - stars.length;
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <span key={`empty-${i}`} className="text-gray-300">★</span>
    );
  }

  return <div className="flex">{stars}</div>;
}

export default function ClinicCard({ clinic, directions, onClick }) {
  return (
    <div 
      className="bg-white rounded-xl shadow hover:shadow-md transition p-0 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex flex-row items-start gap-6 p-6">
        {/* Логотип слева, строго квадратный */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 bg-gray-50 border border-gray-200 rounded-full flex items-center justify-center overflow-hidden">
            <img
              src={clinic.logo}
              alt="Логотип клиники"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        {/* Инфоблок: название, рейтинг, адрес, теги */}
        <div className="flex-1 min-w-0 flex flex-col justify-between">
          <div>
            <div className="flex justify-between items-start mb-3 flex-wrap gap-2">
              <h3 className="text-lg font-semibold text-gray-900">{clinic.name}</h3>
              <div className="flex items-center gap-1 text-sm whitespace-nowrap">
                <RatingStars rating={clinic.rating} />
                <span className="text-gray-700 ml-1">{clinic.rating.toFixed(1)}</span>
              </div>
            </div>
            
            {/* Адрес с иконкой */}
            <div className="flex items-center gap-2 text-gray-600 mb-3">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{clinic.city}, {clinic.address}</span>
            </div>

            {/* Теги */}
            <div className="flex flex-wrap gap-2 mb-0">
              {clinic.tags.map((tag, i) => (
                <span
                  key={i}
                  className="text-xs px-2 py-1 bg-green-50 text-green-600 rounded-full"
                >
                  {directions.find((d) => d.id === tag)?.label || tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Нижняя часть карточки */}
      <div className="border-t px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Расписание */}
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{clinic.schedule}</span>
          </div>

          {/* Кнопка записи */}
          <button 
            className="text-sm text-primary hover:text-primary/90 font-medium flex items-center gap-1"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
          >
            <span>Записаться</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
